import React from 'react';
import styled from 'styled-components';
import { Layout, LayoutItem, Headline, TextButton } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import searchStateContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import PartnerBusinessCardLoader from '../PartnerBusinessCard/PartnerBusinessCardLoader';
import SpacingContainer from '../../common/SpacingContainer/SpacingContainer';
import { messages } from '../../../i18n/messages';
import { DesktopFlyout } from '../Flyout/DesktopFlyout';

type Props = {
  dealerId: string;
  favoritePartner: {
    kvpsid: string;
    tenant: string;
  };
};
export default function DesktopDealerDetails({ dealerId, favoritePartner }: Props) {
  const { dealerRatings, dealerReviews, ratingSummary, isFlyoutOpen } =
    searchStateContext.useMapState();

  const fiveStarRating = dealerRatings?.[dealerId];

  const dispatch = searchStateContext.useMapDispatch();

  const closeDealerDetail = () => {
    dispatch({ type: ActionTypes.setSelectedDealerId, payload: null });
    dispatch({ type: ActionTypes.setDealerReviews, payload: [] });
    dispatch({ type: ActionTypes.setRatingSummary, payload: null });
  };

  return (
    <DealerDetailsContainer data-test-id="dealer-details">
      {isFlyoutOpen && (dealerReviews?.length || ratingSummary) && (
        <DesktopFlyout data-test-id="component-desktop-flyout" />
      )}
      <SpacingContainer style={{ margin: '24px 28px' }}>
        <BackToResultsButton
          variant="tertiary"
          icon="back"
          iconPosition="leading"
          onClick={closeDealerDetail}
          data-test-id="dealer-details-cancel-button"
          aria-label="close dealer details"
          size="md"
        >
          {useI18n(messages.back_to_results)}
        </BackToResultsButton>
        <Layout justify="space-between">
          <LayoutItem align="center" margin={[0, 0, '24px', 0]}>
            <Headline tag="h2" variant={{ order: '4', type: 'headline', weight: 'normal' }}>
              {useI18n(messages.partner_details)}
            </Headline>
          </LayoutItem>
        </Layout>
        <PartnerBusinessCardLoader
          partnerID={dealerId}
          fiveStarRating={fiveStarRating}
          isMobile={false}
          favoritePartner={favoritePartner}
        />
      </SpacingContainer>
    </DealerDetailsContainer>
  );
}

const DealerDetailsContainer = styled.div`
  width: 100%;
  overflow-y: auto;
  background: #fff;

  &::-webkit-scrollbar {
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
  }
`;

const BackToResultsButton = styled(TextButton)`
  margin-bottom: 24px;
  min-height: auto;
  padding: 0;
`;
